module.exports = __webpack_public_path__ + "img/ffi.609a455d.png";